import { render, staticRenderFns } from "./CabeceraModalVisualizacion.vue?vue&type=template&id=99df4d2e&scoped=true&"
import script from "./CabeceraModalVisualizacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalVisualizacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalVisualizacion.vue?vue&type=style&index=0&id=99df4d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df4d2e",
  null
  
)

export default component.exports